//
//
//
//
//
//
//
//
//
//
//
//

import { defaultBlockProps } from "~/helpers/data";

export default {
    name: "BowContentListMediaSx",
    props: {
        ...defaultBlockProps,
    },
    data: () => ({}),
};
